<!-- Loading State -->
<div *ngIf="isLoading" class="divsubscription bg-white px-3 py-5">
  <div>
    <div class="text-center pt-5 pb-5">
      <div class="loader loader--style8" title="7">
        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
           width="24px" height="30px" viewBox="0 0 24 30" style="enable-background:new 0 0 50 50;" xml:space="preserve">
          <rect x="0" y="10" width="4" height="10" fill="#333" opacity="0.2">
            <animate attributeName="opacity" attributeType="XML" values="0.2; 1; .2" begin="0s" dur="0.6s" repeatCount="indefinite" />
            <animate attributeName="height" attributeType="XML" values="10; 20; 10" begin="0s" dur="0.6s" repeatCount="indefinite" />
            <animate attributeName="y" attributeType="XML" values="10; 5; 10" begin="0s" dur="0.6s" repeatCount="indefinite" />
          </rect>
          <rect x="8" y="10" width="4" height="10" fill="#333"  opacity="0.2">
            <animate attributeName="opacity" attributeType="XML" values="0.2; 1; .2" begin="0.15s" dur="0.6s" repeatCount="indefinite" />
            <animate attributeName="height" attributeType="XML" values="10; 20; 10" begin="0.15s" dur="0.6s" repeatCount="indefinite" />
            <animate attributeName="y" attributeType="XML" values="10; 5; 10" begin="0.15s" dur="0.6s" repeatCount="indefinite" />
          </rect>
          <rect x="16" y="10" width="4" height="10" fill="#333"  opacity="0.2">
            <animate attributeName="opacity" attributeType="XML" values="0.2; 1; .2" begin="0.3s" dur="0.6s" repeatCount="indefinite" />
            <animate attributeName="height" attributeType="XML" values="10; 20; 10" begin="0.3s" dur="0.6s" repeatCount="indefinite" />
            <animate attributeName="y" attributeType="XML" values="10; 5; 10" begin="0.3s" dur="0.6s" repeatCount="indefinite" />
          </rect>
        </svg>
      </div>
    </div>  
  </div>   
</div>

<div *ngIf="!isLoading" class="">
  <div class="container pb-5">

    <!-- Breadcrumb -->
    <div class="mb-3">
      <app-breadcrumb 
        returnAction="/dashboard" 
        [breadcrumbs]="[
            { label: 'Company Management', url: '/setting/company-management' },
            { label: 'Berlangganan' }
        ]"
      >
      </app-breadcrumb>
    </div> 

    <!-- Header -->
    <div class="card border-0 mb-3">
      <div class="row">
        <div class="col-sm-12">
          <div class="cd-title">Berlangganan</div>
        </div>
      </div>
    </div>

    <!-- Stepper Navigation -->
    <div class="card border-0 mb-3">
      <div class="cd-content px-3 py-2">


        <div class="subscription-list-container">
        <!-- Langganan Saat Ini (Current Subscriptions) Section -->
        <div class="subscription-section langganan-saat-ini">
            <div class="section-header">
            <h2>Langganan Saat Ini</h2>
            </div>
            
            <div class="subscription-table">
            <table class="table">
                <thead>
                <tr>
                    <th class="text-center">Type</th>
                    <th class="text-center">Paket Langganan</th>
                    <th class="text-center">Fitur</th>
                    <th class="text-center">Kuota</th>
                    <th class="text-center">Berlaku Hingga</th>
                </tr>
                </thead>
                <tbody>
                <!-- Show empty state if no subscriptions -->
                <tr *ngIf="currentSubscriptions.length === 0">
                    <td colspan="5" class="empty-state">
                    <p class="empty-message">Anda tidak memiliki paket aktif saat ini.</p>
                    </td>
                </tr>
                
                <!-- SUBSCRIPTION TYPE SECTION -->
                <ng-container *ngIf="groupedSubscriptions['SUBSCRIPTION'] && groupedSubscriptions['SUBSCRIPTION'].length > 0">
                    <!-- <tr class="section-header-row">
                        <td colspan="4" class="section-type-header"><strong>Subscription</strong></td>
                    </tr> -->
                    <tr *ngFor="let subscription of groupedSubscriptions['SUBSCRIPTION']">
                        <td>
                            <strong>{{ subscription.productCategory }}</strong>
                        </td>
                        <td>
                            <strong>{{ subscription.offeringLabel }}</strong>
                            <br>
                            <small class="text-muted">{{ subscription.activeDate | date: 'dd MMM yyyy' }} - {{ subscription.expiredDate | date: 'dd MMM yyyy' }}</small>
                        </td>
                        <td>
                            <ul *ngIf="subscription.subscriptionFeatures && subscription.subscriptionFeatures.length > 0" class="featurelist mb-0">
                                <li *ngFor="let feature of subscription.subscriptionFeatures">
                                    {{ feature.featureName }}
                                    <span *ngIf="feature.featureAvailableQty" class="badge bg-light text-dark ms-2">{{ feature.featureAvailableQty }}</span>
                                </li>
                            </ul>
                            <span *ngIf="!subscription.subscriptionFeatures || subscription.subscriptionFeatures.length === 0">-</span>
                        </td>
                        <td class="text-end">{{ subscription.offeredQty | number }}</td>
                        <td>{{ subscription.expiredDate | date: 'dd MMM yyyy' }}</td>
                    </tr>
                </ng-container>
                
                <!-- VOUCHER TYPE SECTION -->
                <ng-container *ngIf="groupedSubscriptions['VOUCHER'] && groupedSubscriptions['VOUCHER'].length > 0">
                    <!-- <tr class="section-header-row">
                        <td colspan="4" class="section-type-header"><strong>Voucher</strong></td>
                    </tr> -->

                    <tr *ngFor="let subscription of groupedSubscriptions['VOUCHER']">
                        <td><strong>{{ subscription.productCategory }}</strong> </td>
                        <td>
                            <strong>{{ subscription.offeringLabel }}</strong>
                            <br>
                            <small class="text-muted">{{ subscription.activeDate | date: 'dd MMM yyyy' }} - {{ subscription.expiredDate | date: 'dd MMM yyyy' }}</small>
                        </td>
                        <td>
                            <ul *ngIf="subscription.subscriptionFeatures && subscription.subscriptionFeatures.length > 0" class="featurelist mb-0">
                                <li *ngFor="let feature of subscription.subscriptionFeatures">
                                    {{ feature.featureName }}
                                    <span *ngIf="feature.featureAvailableQty" class="badge bg-light text-dark ms-2">{{ feature.featureAvailableQty }}</span>
                                </li>
                            </ul>
                            <span *ngIf="!subscription.subscriptionFeatures || subscription.subscriptionFeatures.length === 0">-</span>
                        </td>
                        <td class="text-end">{{ subscription.offeredQty | number }}</td>
                        <td>{{ subscription.expiredDate | date: 'dd MMM yyyy' }}</td>
                    </tr>
                </ng-container>
                
                <!-- ADDONS TYPE SECTION -->
                <ng-container *ngIf="groupedSubscriptions['ADDONS'] && groupedSubscriptions['ADDONS'].length > 0">
                    <!-- <tr class="section-header-row">
                        <td colspan="4" class="section-type-header"><strong>Add-ons</strong></td>
                    </tr> -->
                    <tr *ngFor="let subscription of groupedSubscriptions['ADDONS']">
                        <td>
                            <strong>{{ subscription.productCategory }}</strong>  
                        </td>
                        <td>
                            <strong>{{ subscription.offeringLabel }}</strong>
                            <br>
                            <small class="text-muted">{{ subscription.activeDate | date: 'dd MMM yyyy' }} - {{ subscription.expiredDate | date: 'dd MMM yyyy' }}</small>
                        </td>
                        <td>
                            <ul *ngIf="subscription.subscriptionFeatures && subscription.subscriptionFeatures.length > 0" class="featurelist mb-0">
                                <li *ngFor="let feature of subscription.subscriptionFeatures">
                                    {{ feature.featureName }}
                                    <span *ngIf="feature.featureAvailableQty" class="badge bg-light text-dark ms-2">{{ feature.featureAvailableQty }}</span>
                                </li>
                            </ul>
                            <span *ngIf="!subscription.subscriptionFeatures || subscription.subscriptionFeatures.length === 0">-</span>
                        </td>
                        <td class="text-end">{{ subscription.offeredQty | number }}</td>
                        <td>{{ subscription.expiredDate | date: 'dd MMM yyyy' }}</td>
                    </tr>
                </ng-container>
                </tbody>
                <tfoot>
                    <tr>
                        <td colspan="5" class="text-end">
                            <a href="/subscription-products" class="btn btn-primary btn-buy-package px-5">
                                Beli Paket
                            </a>
                        </td>
                    </tr>
                </tfoot>
            </table>
            </div>

            <!-- <div class="section-footer" *ngIf="currentSubscriptions.length === 0">
            <button class="btn btn-primary btn-buy-package">
                Beli Paket
            </button>
            </div> -->
        </div>

        <!-- Tagihan Aktif (Active Invoices) Section -->
        <div class="subscription-section tagihan-aktif">
            <div class="section-header">
            <h2>Tagihan Aktif</h2>
            </div>

            <div class="invoices-table">
            <table class="table">
                <thead>
                <tr>
                    <th class="text-center">No.</th>
                    <th class="text-center">No. Referensi</th>                    
                    <th class="text-center">Tanggal</th>                    
                    <th class="text-center">Nilai Tagihan</th>
                    <th class="text-center">Berlaku Hingga</th>
                    <th class="text-center">Status</th>
                    <th class="text-center">Aksi</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngIf="activeInvoices.length === 0">
                    <td colspan="7" class="empty-state">
                    <p class="empty-message">Anda tidak memiliki tagihan aktif saat ini.</p>
                    </td>
                </tr>
                <tr *ngFor="let invoice of activeInvoices; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>
                    <span class="reference-number"><a href="/billing-list/detail/{{ invoice.proformaInvoiceId }}">#{{ formatDisplayId(invoice.proformaInvoiceNo) }}</a></span>
                    </td>                 
                    <td><span class="cdc1 fw-500">{{ invoice.proformaInvoiceDate | date: 'dd MMM yyyy' }}</span></td>   


                    <td class="text-right">
                    <span class="cdc1" *ngIf="invoice?.openBillingPriceCurrency && invoice.openBillingPriceCurrency.length > 0">
                        {{ invoice.openBillingPriceCurrency[0].currency }} {{ invoice.openBillingPriceCurrency[0].price | number }} 
                    </span>

                    </td>
                    <td><span class="cdc1 fw-500">{{ invoice.proformaInvoiceExpiredDate | date: 'dd MMM yyyy HH:mm' }}</span></td>
                    <td class="text-center">
                    <ng-container [ngSwitch]="invoice.proformaInvoiceStatus.trim()">
                        <span *ngSwitchCase="'none'"></span>
                        <span *ngSwitchCase="'OPEN'" class="badge rounded-pill bg-info">Menunggu Pembayaran</span>
                        <span *ngSwitchCase="'PENDINGAPPROVAL'" class="badge rounded-pill bg-warning text-dark">Dalam Proses</span>
                        <span *ngSwitchCase="'EXPIRED'" class="badge rounded-pill bg-danger">Kadaluarsa</span>
                        <span *ngSwitchDefault class="badge rounded-pill bg-secondary">{{ invoice.proformaInvoiceStatus }}</span>
                    </ng-container>
                    </td>
                    <td>
                    <a href="/billing-list/detail/{{ invoice.proformaInvoiceId }}" class="btn btn-link btn-action">Lihat</a>
                    </td>
                </tr>
                </tbody>
            </table>
            </div>
        </div>

        <!-- Riwayat Pembelian (Purchase History) Section -->
        <div class="subscription-section riwayat-pembelian">
            <div class="section-header">
            <h2>Riwayat Pembelian</h2>
            </div>

            <div class="purchase-history-table">
            <table class="table">
                <thead>
                <tr>
                    <th class="text-center">No.</th>
                    <th class="text-center">No. Referensi</th>
                    <th class="text-center">No. Invoice</th>
                    <th class="text-center">Nilai Tagihan</th>
                    <th class="text-center">Tgl Penagihan</th>
                    <th class="text-center">Status</th>
                    <th class="text-center">Aksi</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngIf="purchaseHistory.length === 0">
                    <td colspan="7" class="empty-state">
                    <p class="empty-message">Anda tidak memiliki riwayat pembelian.</p>
                    </td>
                </tr>
                <tr *ngFor="let purchase of purchaseHistory; let i = index">
                    <td>{{ i + 1 }}</td>
                    <td>
                    <span class="reference-number"><a href="/billing-list/detail/{{ purchase.proformaInvoiceId }}">#{{ formatDisplayId(purchase.proformaInvoiceNo) }}</a></span>
                    </td>
                    <td>
                        <span class="reference-number"><a href="/billing-list/detail/{{ purchase.proformaInvoiceId }}">{{ purchase.invoiceNo ? '#'+formatDisplayId(purchase.invoiceNo) : '-' }}</a></span>
                    </td>
                    <td class="text-right">
                    <span class="cdc1" *ngIf="purchase?.historyBillingPriceCurrency && purchase.historyBillingPriceCurrency.length > 0">
                        {{ purchase.historyBillingPriceCurrency[0].currency }} {{ purchase.historyBillingPriceCurrency[0].price | number }} 
                    </span>
                    </td>
                    <td><span class="cdc1 fw-500">{{ purchase.proformaInvoiceDate | date: 'dd MMM yyyy' }}</span></td>
                    <td  class="text-center">
                    <ng-container [ngSwitch]="purchase.proformaInvoiceStatus.trim()">
                        <span *ngSwitchCase="'none'"></span>
                        <span *ngSwitchCase="'OPEN'" class="badge rounded-pill bg-info">Menunggu Pembayaran</span>
                        <span *ngSwitchCase="'PENDINGAPPROVAL'" class="badge rounded-pill bg-warning text-dark">Dalam Proses</span>
                        <span *ngSwitchCase="'EXPIRED'" class="badge rounded-pill bg-danger">Kadaluarsa</span>
                        <span *ngSwitchCase="'PAYMENTRECEIVED'" class="badge rounded-pill bg-success">Selesai</span>


                        <span *ngSwitchDefault class="badge rounded-pill bg-secondary">{{ purchase.proformaInvoiceStatus }}</span>
                    </ng-container>
                    </td>
                    <td>
                    <a href="/billing-list/detail/{{ purchase.proformaInvoiceId }}" class="btn btn-link btn-action">Lihat</a>
                    </td>
                </tr>
                </tbody>
            </table>
            </div>
        </div>
        </div>



    
      </div>
    </div>
  </div>
</div>



